var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_681_1795)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_681_1795",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_681_1795)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.47 4.46984C13.5397 4.40014 13.6224 4.34486 13.7134 4.30714C13.8044 4.26941 13.902 4.25 14.0005 4.25C14.099 4.25 14.1966 4.26941 14.2876 4.30714C14.3786 4.34486 14.4613 4.40014 14.531 4.46984L21.531 11.4698C21.6007 11.5395 21.656 11.6222 21.6937 11.7132C21.7314 11.8042 21.7508 11.9018 21.7508 12.0003C21.7508 12.0989 21.7314 12.1964 21.6937 12.2875C21.656 12.3785 21.6007 12.4612 21.531 12.5308L14.531 19.5308C14.4613 19.6005 14.3786 19.6558 14.2876 19.6935C14.1966 19.7312 14.099 19.7506 14.0005 19.7506C13.902 19.7506 13.8044 19.7312 13.7134 19.6935C13.6224 19.6558 13.5397 19.6005 13.47 19.5308C13.4003 19.4612 13.3451 19.3785 13.3074 19.2874C13.2697 19.1964 13.2503 19.0989 13.2503 19.0003C13.2503 18.9018 13.2697 18.8043 13.3074 18.7132C13.3451 18.6222 13.4003 18.5395 13.47 18.4698L19.19 12.7498H3C2.80109 12.7498 2.61032 12.6708 2.46967 12.5302C2.32902 12.3895 2.25 12.1988 2.25 11.9998C2.25 11.8009 2.32902 11.6102 2.46967 11.4695C2.61032 11.3289 2.80109 11.2498 3 11.2498H19.189L13.47 5.52984C13.3295 5.38921 13.2507 5.19859 13.2507 4.99984C13.2507 4.80109 13.3295 4.61046 13.47 4.46984Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_681_1795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next-arrow.3fbb53935e2bb0b0d95f1109883d86a5.svg";
export { ForwardRef as ReactComponent };